// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"521":"zxcvbnEnPackage","767":"zxcvbnCommonPackage"}[chunkId] || chunkId) + "." + {"453":"23deb2dd","521":"5f1285ed","767":"c98c9511"}[chunkId] + ".chunk.js";
};